module.exports = __webpack_public_path__ + "img/audio-error-image.1a3d79d4.svg";